/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
/**
 * Event if helpers exists (e.g. Blob.text()), we use a FileReader in order to be compatible with
 * more browsers and tests environments.
 * @param blob
 */
export class BlobIO {
    static asString(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = (err) => reject(err);
            reader.readAsText(blob);
        });
    }
    static async asArrayBuffer(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = (err) => reject(err);
            reader.readAsArrayBuffer(blob);
        });
    }
    static async canvasToPng(canvas) {
        return new Promise((resolve, reject) => {
            const cb = (b) => {
                if (b) {
                    resolve(b);
                }
                else {
                    reject(new Error('Unexpected error'));
                }
            };
            canvas.toBlob(cb, 'image/png', 1);
        });
    }
    static blobUrlToBlob(url) {
        return fetch(url).then((r) => r.blob());
    }
}
//# sourceMappingURL=BlobIO.js.map